module.exports = {"center":[40.42,-3.7794],"zoom":4}


//////////////////
// WEBPACK FOOTER
// ./src/store/config/defaultMap.json
// module id = Ei+O
// module chunks = 1